import { platformService } from './platform';
import { InviteDetails } from '../../../types';
import { appLinkService } from '../../../services/appLink';

const getLink = (inviteDetails: InviteDetails) => {
  const { appType, brandedData } = inviteDetails;
  const isBranded = appType === 'WixBrandedApp';

  if (isBranded && brandedData) {
    const platform = platformService.getMobilePlatform();
    const { storesConfig } = brandedData;
    return platform === 'Android'
      ? storesConfig.playStore.downloadLink
      : storesConfig.appStore.downloadLink;
  }

  return appLinkService.getAppLink({ inviteDetails });
};

const openLink = (inviteDetails: InviteDetails) => {
  const appLink = getLink(inviteDetails);
  window.location.assign(appLink);
};

export const downloadService = {
  openLink,
};
